module.exports = __webpack_public_path__ + "static/media/gold.67430be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/gold.png
// module id = 53
// module chunks = 0